import { render, staticRenderFns } from "./ProductsComponent.vue?vue&type=template&id=03b74602&"
import script from "./ProductsComponent.vue?vue&type=script&lang=js&"
export * from "./ProductsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports